import { UserType } from '@webc/meeseeks-ui-sdk';
import { StoreState } from 'app/models/types';

export const userTypeSelector = (state: StoreState): UserType =>
  state.general.options.userType || 'customer';
